// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__335-F","buttons":"SendReceipts_buttons__3NnqH","email":"SendReceipts_email__oU0v8","bookApptTitle":"SendReceipts_bookApptTitle__3bqBU"};